import { render } from "./AsistenciaList.vue?vue&type=template&id=6e65ffbf&scoped=true"
import script from "./AsistenciaList.vue?vue&type=script&lang=js"
export * from "./AsistenciaList.vue?vue&type=script&lang=js"

import "./AsistenciaList.vue?vue&type=style&index=0&id=6e65ffbf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e65ffbf"]])

export default __exports__